import React from 'react';

const Card = ({ children, className = '' }) => (
    <div className={`bg-white rounded-2xl border border-amber-100/30 warm-tactile-shadow p-5 sm:p-6 ${className}`}>
        {children}
    </div>
);

export default Card;
